const alertCookieName = 'alert-box';

function getCookie(name) {
  return document.cookie.split('; ').find((cookie) => cookie.startsWith(`${name}=`))?.split('=')[1];
}

export function initializeAlertRibbon() {
  const alert = document.querySelector('#global_alert');
  const closeButton = alert?.querySelector('#close');
  if (!alert || !closeButton) return;

  if (getCookie(alertCookieName) === 'closed') {
    alert.hidden = true;
    return;
  }

  closeButton.addEventListener('click', (event) => {
    event.preventDefault();
    document.cookie = `${alertCookieName}=closed; path=/; max-age=31536000; samesite=lax`;
    closeButton.disabled = true;
    alert.classList.add('is-closing');

    const hideAlert = () => {
      alert.hidden = true;
    };

    alert.addEventListener('transitionend', hideAlert, { once: true });
    window.setTimeout(hideAlert, 350);
  });

}
